import { CheckCircle2, Circle } from "lucide-react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { formatDateTime } from "@helpers/date";
import { SIGNATURE_PARTIES } from "../misc/constants";

const Signature = ({ label, signed, detail }) => (
    <span
        className={classnames("inline-flex items-center gap-1 text-xs", signed ? "text-success" : "text-muted")}
        title={detail}>
        {signed ? <CheckCircle2 className="h-3.5 w-3.5" /> : <Circle className="h-3.5 w-3.5" />}
        {label}
    </span>
);

Signature.propTypes = {
    label : PropTypes.string.isRequired,
    signed: PropTypes.bool,
    detail: PropTypes.string
};

// "Acme Media · 28 Sep 2026, 10:42 AM", for the hover title.
const detailOf = (signature) => (signature
    ? [signature.name, signature.signedAt && formatDateTime(signature.signedAt)].filter(Boolean).join(" · ")
    : "Not signed yet");

// What the server stamped into this contract — Ops, brand and publisher, in
// signing order, with who signed and when on hover. Ops signs when it sends,
// so a contract that has not been sent has no signatures at all.
const SignaturesCell = ({ signatures }) => {
    if (!signatures) return <span className="text-gray-700">—</span>;

    return (
        <div className="flex flex-wrap items-center gap-3">
            {SIGNATURE_PARTIES.map(({ key, label }) => (
                <Signature
                    key={key}
                    label={label}
                    signed={Boolean(signatures[key])}
                    detail={detailOf(signatures[key])} />
            ))}
        </div>
    );
};

SignaturesCell.propTypes = {
    signatures: PropTypes.object
};

export default SignaturesCell;
